import {SelectorIcon} from '@heroicons/react/outline'
import {ArrowNarrowDownIcon, ArrowNarrowUpIcon} from '@heroicons/react/solid'
import {useMantineTheme} from '@mantine/core'
import {HeaderCell} from '@table-library/react-table-library'
import {HeaderCellProps} from '@table-library/react-table-library/types/table'
import React from 'react'
import {TransparentActionIcon} from '../consumables/transparent-action-icon'
import {mode} from '@appscience/utils'
import {DataTableOneFilterInfo} from '../../model'
import {DataTableFilterAction} from './filter-action'

type SortState = 'normal'|'asc'|'desc'

export interface DefaultHeaderCellSortInfo {
  state: SortState,
  onToggleSort: () => void,
}

interface DefaultHeaderCellProps extends HeaderCellProps {
  title: React.ReactNode,
  sortInfo?: DefaultHeaderCellSortInfo,
  filterData?: DataTableOneFilterInfo,
  loading?: boolean,
}

export function DataTableHeaderCell({
  title,
  sortInfo,
  filterData,
  loading,
  ...props
}: DefaultHeaderCellProps) {
  const {colors, colorScheme} = useMantineTheme()
  const getArrowColor = () => mode(colors.blue[4], colors.blue[4])(colorScheme)

  function getSortIcon(state: SortState) {
    if (state === 'asc') {
      return <ArrowNarrowDownIcon className='w-4 h-4' color={getArrowColor()} />
    }
    if (state === 'desc') {
      return <ArrowNarrowUpIcon className='w-4 h-4' color={getArrowColor()}/>
    }
    return <SelectorIcon className='w-4 h-4' color={mode(colors.gray[5], colors.gray[5])(colorScheme)}/>
  }

  return (
    <HeaderCell {...props} >
      <div className='flex items-center' onClick={() => sortInfo && sortInfo.onToggleSort()}>
        {title}
        {sortInfo && <TransparentActionIcon size='md' disabled={loading} className='min-w-min w-auto p-[1px] pr-0'>
          {getSortIcon(sortInfo.state)}
        </TransparentActionIcon>}
      </div>
      {filterData && <DataTableFilterAction disabled={loading} {...filterData} />}
    </HeaderCell>
  )
}